// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowThickUp = function IconArrowThickUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"title","attr":{}},{"tag":"polygon","attr":{"id":"fill-color","transform":"translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) ","points":"8.90283401 4 7 5.88 13.1808367 12 7 18.12 8.90283401 20 17 12"}}]})(props);
};
